import { useCallback, useState } from 'react'
import { FIRST_CITY } from '../lib/content'
import { useTitle } from '../hooks/useTitle'
import { ErrorBoundary } from '../components/ui/ErrorBoundary'
import { Hero } from '../components/Hero/Hero'
import { Ribbon } from '../components/Ribbon/Ribbon'
import { Explore } from '../components/Explore/Explore'
import { Features } from '../components/Features/Features'
import { Host } from '../components/Host/Host'
import { BusinessTeaser } from '../components/Business/BusinessTeaser'
import { Safety } from '../components/Safety/Safety'
import { Cities } from '../components/Cities/Cities'
import { Waitlist } from '../components/Waitlist/Waitlist'

export function HomePage() {
  useTitle('mauj · plans happening near you', '/')
  const [votes, setVotes] = useState<Record<string, boolean>>({})
  const [city, setCity] = useState<string>(FIRST_CITY)

  // Voting for a city also preselects it in the waitlist form.
  const vote = useCallback((c: string) => {
    setVotes((v) => {
      const on = !v[c]
      if (on) setCity(c)
      return { ...v, [c]: on }
    })
  }, [])

  return (
    <>
      <ErrorBoundary name="hero"><Hero /></ErrorBoundary>
      <ErrorBoundary name="ribbon"><Ribbon /></ErrorBoundary>
      <ErrorBoundary name="explore"><Explore /></ErrorBoundary>
      <ErrorBoundary name="features"><Features /></ErrorBoundary>
      <ErrorBoundary name="host"><Host /></ErrorBoundary>
      <ErrorBoundary name="safety"><Safety /></ErrorBoundary>
      <ErrorBoundary name="business"><BusinessTeaser /></ErrorBoundary>
      <ErrorBoundary name="cities"><Cities votes={votes} onVote={vote} /></ErrorBoundary>
      <ErrorBoundary name="waitlist"><Waitlist city={city} onCityChange={setCity} /></ErrorBoundary>
    </>
  )
}
